/**
 * Mock provider documents — used by the provider DocumentsPage.
 *
 * Keyed by provider user_id so the page can fetch the current dev provider's
 * uploaded docs without a real Supabase backend.
 */

import type { Tables } from '@/lib/db.types'
import { DEV_USER_IDS } from './ids'

type ProviderDocument = Tables<'provider_documents'>

const NOW = Date.parse('2026-05-01T08:00:00.000Z')
const T = (daysAgo: number) => new Date(NOW - daysAgo * 86400_000).toISOString()

// DocumentsPage filters by user_id (not provider entity id), so we key by user_id.
export const MOCK_DOCUMENTS_BY_USER: Record<string, ProviderDocument[]> = {
  [DEV_USER_IDS.provider]: [
    {
      id: 'doc-dev-1',
      provider_id: DEV_USER_IDS.provider, // intentionally user_id so the page query matches
      kind: 'f_skatt',
      file_url: '#mock-fskatt.pdf',
      file_name: 'F-skattsedel-2026.pdf',
      verified: true,
      verified_at: T(60),
      verified_by: DEV_USER_IDS.admin,
      notes: 'Verifierad mot Skatteverket.',
      created_at: T(80),
    },
    {
      id: 'doc-dev-2',
      provider_id: DEV_USER_IDS.provider,
      kind: 'insurance',
      file_url: '#mock-insurance.pdf',
      file_name: 'Ansvarsforsakring-Lansforsakringar-2026.pdf',
      verified: true,
      verified_at: T(45),
      verified_by: DEV_USER_IDS.admin,
      notes: 'Försäkringsbelopp upp till 10 MSEK.',
      created_at: T(75),
    },
    {
      id: 'doc-dev-3',
      provider_id: DEV_USER_IDS.provider,
      kind: 'id_proof',
      file_url: '#mock-id.jpg',
      file_name: 'BankID-verifiering.jpg',
      verified: true,
      verified_at: T(420),
      verified_by: DEV_USER_IDS.admin,
      notes: null,
      created_at: T(420),
    },
    {
      id: 'doc-dev-4',
      provider_id: DEV_USER_IDS.provider,
      kind: 'license',
      file_url: '#mock-license.pdf',
      file_name: 'Byggvarudeklaration.pdf',
      verified: false,
      verified_at: null,
      verified_by: null,
      notes: 'Väntar på granskning från admin.',
      created_at: T(5),
    },
    {
      id: 'doc-dev-5',
      provider_id: DEV_USER_IDS.provider,
      kind: 'other',
      file_url: '#mock-other.pdf',
      file_name: 'Certifikat-snickeri.pdf',
      verified: true,
      verified_at: T(380),
      verified_by: DEV_USER_IDS.admin,
      notes: null,
      created_at: T(400),
    },
  ],
}

export function findDocumentsByUserId(userId: string): ProviderDocument[] {
  return MOCK_DOCUMENTS_BY_USER[userId] ?? []
}

